"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useReducerGetState_1 = __importDefault(require("./utils/useReducerGetState"));
var AcdcContext_1 = require("./AcdcContext");
var ActionTypes;
(function (ActionTypes) {
    ActionTypes["InputChange"] = "inputChange";
    ActionTypes["InputFocus"] = "inputFocus";
    ActionTypes["InputBlur"] = "inputBlur";
    ActionTypes["InputClick"] = "inputClick";
    ActionTypes["KeyDownArrowDown"] = "keyDownArrowDown";
    ActionTypes["KeyDownArrowUp"] = "keyDownArrowUp";
    ActionTypes["KeyDownEnter"] = "keyDownEnter";
    ActionTypes["KeyDownEscape"] = "keyDownEscape";
    ActionTypes["KeyDownUnknown"] = "keyDownUnknown";
    ActionTypes["OptionMouseEnter"] = "optionMouseEnter";
    ActionTypes["OptionMouseLeave"] = "optionMouseLeave";
    ActionTypes["OptionClick"] = "optionClick";
    ActionTypes["PopupBlur"] = "popupBlur";
    ActionTypes["MergeState"] = "mergeState";
})(ActionTypes = exports.ActionTypes || (exports.ActionTypes = {}));
exports.defaultInitialState = {
    isOpen: false,
    value: '',
    selectedIndex: null,
    mouseHighlightedIndex: null,
    keyboardHighlightedIndex: null,
};
exports.combineState = function (state, controlledState) {
    var result = state;
    Object.keys(state).forEach(function (key) {
        var _a;
        if (controlledState[key] !== undefined) {
            result = __assign(__assign({}, result), (_a = {}, _a[key] = controlledState[key], _a));
        }
    });
    return result;
};
exports.wrapCallback = function (prev, next, callback) {
    if (callback && prev !== next) {
        callback(next);
    }
};
var useAcdcReducer = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.stateReducer, stateReducer = _b === void 0 ? function (state, changes) { return changes.nextState; } : _b, _c = _a.initialState, initialState = _c === void 0 ? {} : _c, onChange = _a.onChange, onIsOpenChange = _a.onIsOpenChange, onSelectedIndexChange = _a.onSelectedIndexChange, onMouseHighlightedIndexChange = _a.onMouseHighlightedIndexChange, onKeyboardHighlightedIndexChange = _a.onKeyboardHighlightedIndexChange, controlledState = __rest(_a, ["stateReducer", "initialState", "onChange", "onIsOpenChange", "onSelectedIndexChange", "onMouseHighlightedIndexChange", "onKeyboardHighlightedIndexChange"]);
    var ctx = AcdcContext_1.useAcdcElementRegistryContext();
    var getValueMap = ctx.getValueMap, getIndices = ctx.getIndices, getInputElement = ctx.getInputElement, getOptionElement = ctx.getOptionElement;
    var _d = __read(useReducerGetState_1.default(function (reducerState, action) {
        var state = exports.combineState(reducerState, controlledState);
        var currentIndices = getIndices();
        var currentValueMap = getValueMap();
        var event = {
            currentTarget: getInputElement(),
            target: getInputElement(),
        };
        var nextState = state;
        switch (action.type) {
            case ActionTypes.InputChange: {
                nextState = __assign(__assign({}, state), { value: action.value, isOpen: true });
                break;
            }
            case ActionTypes.InputFocus: {
                break;
            }
            case ActionTypes.InputClick: {
                nextState = __assign(__assign({}, state), { isOpen: !state.isOpen });
                break;
            }
            case ActionTypes.KeyDownEscape:
            case ActionTypes.PopupBlur:
            case ActionTypes.InputBlur: {
                nextState = __assign(__assign({}, state), { isOpen: false, keyboardHighlightedIndex: state.selectedIndex });
                break;
            }
            case ActionTypes.KeyDownArrowDown: {
                if (!state.isOpen) {
                    nextState = __assign(__assign({}, state), { isOpen: true });
                }
                else {
                    var keyboardHighlightedIndex = state.keyboardHighlightedIndex;
                    if (currentIndices.length > 0) {
                        if (keyboardHighlightedIndex === null) {
                            keyboardHighlightedIndex = currentIndices[0];
                        }
                        else {
                            var idx = currentIndices.indexOf(state.keyboardHighlightedIndex);
                            if (idx >= currentIndices.length - 1) {
                                keyboardHighlightedIndex = currentIndices[0];
                            }
                            else {
                                keyboardHighlightedIndex = currentIndices[idx + 1];
                            }
                        }
                    }
                    nextState = __assign(__assign({}, state), { isOpen: true, keyboardHighlightedIndex: keyboardHighlightedIndex });
                }
                event.target = getOptionElement(nextState.keyboardHighlightedIndex);
                break;
            }
            case ActionTypes.KeyDownArrowUp: {
                if (!state.isOpen) {
                    nextState = __assign(__assign({}, state), { isOpen: true });
                }
                else {
                    var keyboardHighlightedIndex = state.keyboardHighlightedIndex;
                    if (currentIndices.length > 0) {
                        if (keyboardHighlightedIndex === null) {
                            keyboardHighlightedIndex = currentIndices[currentIndices.length - 1];
                        }
                        else {
                            var idx = currentIndices.indexOf(state.keyboardHighlightedIndex);
                            if (idx <= 0) {
                                keyboardHighlightedIndex = currentIndices[currentIndices.length - 1];
                            }
                            else {
                                keyboardHighlightedIndex = currentIndices[idx - 1];
                            }
                        }
                    }
                    nextState = __assign(__assign({}, state), { isOpen: true, keyboardHighlightedIndex: keyboardHighlightedIndex });
                }
                event.target = getOptionElement(nextState.keyboardHighlightedIndex);
                break;
            }
            case ActionTypes.KeyDownEnter: {
                var nextValue = currentValueMap[state.keyboardHighlightedIndex];
                nextState = __assign(__assign({}, state), { isOpen: false, value: nextValue === undefined ? state.value : nextValue, selectedIndex: state.keyboardHighlightedIndex });
                event.target = getOptionElement(nextState.selectedIndex);
                break;
            }
            case ActionTypes.KeyDownUnknown: {
                break;
            }
            case ActionTypes.OptionMouseEnter: {
                nextState = __assign(__assign({}, state), { mouseHighlightedIndex: action.index });
                event.target = getOptionElement(action.index);
                event.currentTarget = event.target;
                break;
            }
            case ActionTypes.OptionMouseLeave: {
                nextState = __assign(__assign({}, state), { mouseHighlightedIndex: null });
                event.target = getOptionElement(action.index);
                event.currentTarget = event.target;
                break;
            }
            case ActionTypes.OptionClick: {
                nextState = __assign(__assign({}, state), { isOpen: false, selectedIndex: action.index, value: currentValueMap[action.index] });
                event.target = getOptionElement(action.index);
                event.currentTarget = event.target;
                break;
            }
            case ActionTypes.MergeState: {
                nextState = exports.combineState(state, action.state);
                break;
            }
            default:
                throw new Error("Unhandled type: " + action.type + " in useAcdcReducer");
        }
        var semiFinalState = stateReducer(state, {
            action: __assign(__assign({}, action), { valueMap: currentValueMap, indices: currentIndices, event: event }),
            nextState: nextState,
        });
        exports.wrapCallback(state.value, semiFinalState.value, function (val) { if (onChange) {
            onChange(val, event);
        } });
        exports.wrapCallback(state.isOpen, semiFinalState.isOpen, onIsOpenChange);
        exports.wrapCallback(state.selectedIndex, semiFinalState.selectedIndex, onSelectedIndexChange);
        exports.wrapCallback(state.mouseHighlightedIndex, semiFinalState.mouseHighlightedIndex, onMouseHighlightedIndexChange);
        exports.wrapCallback(state.keyboardHighlightedIndex, semiFinalState.keyboardHighlightedIndex, onKeyboardHighlightedIndexChange);
        return semiFinalState;
    }, exports.combineState(exports.combineState(exports.defaultInitialState, initialState), controlledState)), 2), acdcState = _d[0], dispatch = _d[1];
    var finalState = exports.combineState(acdcState, controlledState);
    return {
        dispatch: dispatch,
        state: finalState,
        getValueMap: getValueMap,
        getIndices: getIndices,
    };
};
exports.default = useAcdcReducer;
